// extracted by mini-css-extract-plugin
export var displayNone = "_ub-6";
export var imgContainer = "_ub-2";
export var overflowHidden = "_ub-3";
export var productInfoCardButtonContainer = "_ub-5";
export var productTitleText = "_ub-4";
export var rightArrow = "_ub-1";
export var rightArrowContainer = "_ub-0";